import { vueCreateAppInit } from '../initVariable';

const dragMapZoomFn = (marker, defaultZoom) => {
  return (map) => {
    if (!map) return;
    const element = marker._icon;
    element.style && (element.style.transition = `transform 0.1s`);
    marker.dragging && marker.dragging.disable && marker.dragging.disable();
    const zoom = defaultZoom || map.getZoom();
    marker.options['defaultZoom'] = zoom;
    return () => {
      marker.dragging && marker.dragging.enable && marker.dragging.enable();
      marker.options['defaultZoom'] = undefined;
      element.style && (element.style.transition = `transform 0.1s`);
    }
    const fn = (e) => {
      const changeZoom = map.getZoom();
      const scale = Math.pow(1.5, changeZoom - zoom);
      element && (element.style.transform = `${element.style.transform} scale(${scale})`);
    }
    defaultZoom && fn();
    map.on('zoom', fn);
    return () => {
      map.off('zoom', fn);
      marker.dragging && marker.dragging.enable && marker.dragging.enable();
    }
  }
}

export const dragPopupCreate = (latlng, content, iconConfig, { endLatlng, zoom, lineShow = true, } = {}) => {
  if (!latlng) { throw new Error('latlng 为必填参数'); }
  const group = L.featureGroup(),
    icon = L.divIcon({ html: content, ...iconConfig });
  endLatlng = endLatlng || L.latLng({ lat: latlng.lat + 0.2, lng: (latlng.lng || latlng.lon) + 0.2 })

  let startLatlng = latlng; // 可变引用，供外部更新
  const latlngs = [startLatlng, endLatlng,];

  const polyline = L.polyline(latlngs, {
    weight: 2,
  }),
    popup = L.marker(endLatlng, {
      icon, draggable: true,
      pane: 'popupPane',
    }).on({
      drag: drag => {
        polyline.setLatLngs([
          startLatlng, drag.latlng,
        ])
      },
    }).addTo(group);
  lineShow && polyline.addTo(group);
  const zoomFn = dragMapZoomFn(popup, zoom);

  /** 更新引线起点坐标 */
  const updateStartLatLng = (newLatlng) => {
    startLatlng = newLatlng;
    const currentEnd = popup.getLatLng();
    polyline.setLatLngs([startLatlng, currentEnd]);
  };

  return { zoomFn, group, polyline, updateStartLatLng };
}

export const dragPopupComCreate = (latlng, iconConfig, fnConfig = {}) => {
  return (component, config) => {
    const app = vueCreateAppInit(component, config),
      div = document.createElement('div');
    app.mount(div);
    return {
      app, ...dragPopupCreate(latlng, div, iconConfig, fnConfig),
    };
  }
}
